import type { ReactNode } from "react";

type ErrorBannerProps = {
  children: ReactNode;
  className?: string;
};

export default function ErrorBanner({ children, className = "" }: ErrorBannerProps) {
  return (
    <div
      role="alert"
      className={`rounded-xl border border-red-200 bg-red-50 p-4 text-sm text-red-700 ${className}`}
    >
      {children}
    </div>
  );
}
